import { render } from "./keysDialog.vue?vue&type=template&id=8000a34e&scoped=true"
import script from "./keysDialog.vue?vue&type=script&lang=js"
export * from "./keysDialog.vue?vue&type=script&lang=js"

import "./keysDialog.vue?vue&type=style&index=0&id=8000a34e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8000a34e"]])

export default __exports__